import { isFollowingsNotificationDetails as typeGuard } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";

export { default } from "./NotificationFollowings.vue";

export const selector = (item: Notification): boolean => {
  return typeGuard(item.details);
};
